import { Component, forwardRef } from "react";
import Header from "../../../common_components/Header";
import Loader from "../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import Pagination from "../../../utils/pagination";
import { withRouter } from "../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from "../../../actions/fillCombo_action";
import {
  downloadReport,
  toastError,
  toastSuccess,
} from "../../../utils/constants";
import AdminDrawer from "../../../common_components/admin_module_drawer";
import Modal from "react-modal";
import Footerwithdr from "../../../common_components/Footerwithdr";
import HeaderWithLogo from "../../../common_components/header_with_logo";
import "react-datepicker/dist/react-datepicker.css";
import { getVendorDashboardData_action } from "../../../actions/vendor_module_action/vendor_order_action";
import VendorDrawer from "../../../common_components/vendor_module_drawer";

class VendorDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      // Input Fields
      pendingPaymentCount: "",
      dashboardData: null,
      showVideoModal: false,
    };
    // this.getDashboardData = this.getDashboardData.bind(this)
  }

  // On Component Load
  componentDidMount() {
    console.log(this.props.location);
    this.getDashboardData();
  }

  getDashboardData = () => {
    this.setState({ isLoading: true });
    const exhibitionID = JSON.parse(sessionStorage.getItem("sessionExhibitionID"));

    this.props.getVendorDashboardData_action(exhibitionID)
      .then((res) => {
        if (res.error === 0) {
          this.setState({
            dashboardData: res.data,
            isLoading: false
          });
        } else {
          this.setState({ isLoading: false });
        }
      })
      .catch((err) => {
        console.error(err);
        this.setState({ isLoading: false });
      });
  };

  render() {
    const { isLoading, pendingPaymentCount, summaryPage, dashboardData, showVideoModal } = this.state;

    // Extract service IDs and check if vendor has only ServiceId 32
    const serviceIds = dashboardData?.serviceids || [];
    const hasOnlyService32 = serviceIds.length === 1 && serviceIds[0]?.ServiceId === 32;
    return (
      <>
        {isLoading ? <Loader></Loader> : null}

        <ToastContainer />
        {showVideoModal && (
          <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }} onClick={() => this.setState({ showVideoModal: false })}>
            <div className="modal-dialog modal-lg modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Dashboard</h5>
                  <button type="button" className="btn-close" onClick={() => this.setState({ showVideoModal: false })}></button>
                </div>
                <div className="modal-body">
                  <video controls autoPlay style={{ width: '100%' }}>
                    <source src="/assets/VendorDashboard.mp4" type="video/mp4" />
                  </video>
                </div>
              </div>
            </div>
          </div>
        )}
        <HeaderWithLogo />
        {
          JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID == 7 ?
            <VendorDrawer /> : <AdminDrawer />
        }
        <main className="main-content p-3 pt-2 vendor-top-space">
          <div className="d-flex justify-content-end mb-2 mt-1">
            <span
              onClick={() => this.setState({ showVideoModal: true })}
              style={{ cursor: 'pointer', color: '#3dbca7', fontSize: '16px' }}
            >
              <i className="bi bi-play-circle-fill me-2"></i>User Manual
            </span>
          </div>
          {/* Top Summary Cards */}
          {!hasOnlyService32 && (
            <div className="row gy-3">
              {/* New Requests */}
              <div className="col-xl-3 col-md-6">
                <div className="card shadow-none mb-0 h-100" style={{ cursor: (dashboardData?.newReqCard?.[0]?.NewRequests || 0) > 0 ? 'pointer' : 'default', transition: 'all 0.3s ease' }} onClick={(dashboardData?.newReqCard?.[0]?.NewRequests || 0) > 0 ? () => {
                  sessionStorage.setItem("summaryPage", "vendorExhibitionList");
                  sessionStorage.setItem("filterStatusID", "3");
                  if (this.props.onNavigateToOrder) {
                    this.props.onNavigateToOrder();
                  }
                } : undefined} onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-5px)'} onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}>
                  <div
                    className="card-body py-3 rounded-2"
                    style={{
                      background: "#fff4e8",
                      border: "1px solid #fed5a9",
                      transition: 'all 0.3s ease'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.background = '#e9fffb'}
                    onMouseLeave={(e) => e.currentTarget.style.background = '#f1f1f1'}
                  >
                    <div className="d-flex justify-content-between align-items-start">
                      <div>
                        <div className="stat-label mb-1">
                          <h6>New Requests</h6>
                        </div>
                        <div className="stat-value">{dashboardData?.newReqCard?.[0]?.NewRequests || '0'}</div>
                      </div>
                      {(dashboardData?.newReqCard?.[0]?.NewRequests || 0) > 0 && (
                        <span className="card-header d-flex justify-content-between align-items-center py-1">
                          <i className="bi bi-bell me-1"></i> Action Needed
                        </span>
                      )}
                    </div>
                    <p className="text-muted mb-0 mt-2">
                      New request not yet seen.
                    </p>
                  </div>
                </div>
              </div>
              {/* Total Services */}
              <div className="col-xl-3 col-md-6">
                <div
                  className="card shadow-none mb-0 h-100"
                  style={{
                    background: "#f1f1f1",
                    border: "1px solid #dbdbdb",
                    cursor: 'pointer',
                    transition: 'all 0.3s ease'
                  }}
                  onClick={() => {
                    sessionStorage.setItem("summaryPage", "VendorWorkOrderList");
                    if (this.props.onNavigateToScopeOfWork) {
                      this.props.onNavigateToScopeOfWork();
                    }
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-5px)'}
                  onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                >
                  <div className="card-body py-3 rounded-2" style={{
                    background: "#f1f1f1",
                    border: "1px solid #dfdfdf",
                    transition: 'all 0.3s ease'
                  }}
                    onMouseEnter={(e) => e.currentTarget.style.background = '#e9fffb'}
                    onMouseLeave={(e) => e.currentTarget.style.background = '#f1f1f1'}>
                    <div className="d-flex justify-content-between align-items-start">
                      <div>
                        <div className="stat-label mb-1">
                          <h6>All Services</h6>
                        </div>
                        <div className="stat-value">{dashboardData?.serviceCard?.[0]?.Allservices || '0'}</div>
                      </div>
                    </div>
                    <p className="text-muted mb-0 mt-2">
                      The services you are delivering.
                    </p>
                  </div>
                </div>
              </div>
              {/* Pending Applications */}
              <div className="col-xl-3 col-md-6">
                <div
                  className="card shadow-none mb-0"
                  style={{
                    background: "#f1f1f1",
                    border: "1px solid #dbdbdb",
                    cursor: 'pointer',
                    transition: 'all 0.3s ease'
                  }}
                  onClick={() => {
                    sessionStorage.setItem("summaryPage", "vendorExhibitionList");
                    sessionStorage.setItem("filterStatusID", "1");
                    if (this.props.onNavigateToOrder) {
                      this.props.onNavigateToOrder();
                    }
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-5px)'}
                  onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                >
                  <div className="card-body py-3 rounded-2" style={{
                    background: "#f1f1f1",
                    border: "1px solid #dfdfdf",
                    transition: 'all 0.3s ease'
                  }}
                    onMouseEnter={(e) => e.currentTarget.style.background = '#e9fffb'}
                    onMouseLeave={(e) => e.currentTarget.style.background = '#f1f1f1'}>
                    <div className="d-flex justify-content-between align-items-start">
                      <div>
                        <div className="stat-label mb-1">
                          <h6>Pending Request</h6>
                        </div>
                        <div className="stat-value">{dashboardData?.pendingAppCard?.[0]?.Pending || '0'}</div>
                      </div>
                    </div>
                    <p className="text-muted mb-0 mt-2">
                      Total pending applications across all
                      services.
                    </p>
                  </div>
                </div>
              </div>
              {/* Confirmed Applications */}
              <div className="col-xl-3 col-md-6">
                <div
                  className="card shadow-none mb-0"
                  style={{
                    background: "#f1f1f1",
                    border: "1px solid #dbdbdb",
                    cursor: 'pointer',
                    transition: 'all 0.3s ease'
                  }}
                  onClick={() => {
                    sessionStorage.setItem("summaryPage", "vendorExhibitionList");
                    sessionStorage.setItem("filterStatusID", "2");
                    if (this.props.onNavigateToOrder) {
                      this.props.onNavigateToOrder();
                    }
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-5px)'}
                  onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                >
                  <div className="card-body py-3 rounded-2" style={{
                    background: "#f1f1f1",
                    border: "1px solid #dfdfdf",
                    transition: 'all 0.3s ease'
                  }}
                    onMouseEnter={(e) => e.currentTarget.style.background = '#e9fffb'}
                    onMouseLeave={(e) => e.currentTarget.style.background = '#f1f1f1'}>
                    <div className="d-flex justify-content-between align-items-start">
                      <div>
                        <div className="stat-label mb-1">
                          <h6>Confirmed Request</h6>
                        </div>
                        <div className="stat-value">{dashboardData?.confirmedAppCard?.[0]?.Confirmed || '0'}</div>
                      </div>
                    </div>
                    <p className="text-muted mb-0 mt-2">
                      Total confirmed applications across all
                      services.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="row mt-3">
            {/* Pending Activities Header */}
            <div className="col-12">
              <div className="card border shadow-none p-0  mb-3">
                <div className="card-header d-flex flex-wrap justify-content-between align-items-center gap-2 py-2 bg-light">
                  <h6 className="card-title mb-0">Pending Activities</h6>
                </div>
                <div className="card-body p-2">
                  <div className="row g-3">
                    {dashboardData?.pendingActivityCards?.map((activity, index) => (
                      <div key={index} className="col-md-6 col-lg-4">
                        <div
                          className="card border p-2 mb-0"
                          style={{ cursor: 'pointer', transition: 'all 0.3s ease' }}
                          onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-5px)'; e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.1)'; e.currentTarget.style.background = '#f8f9fa'; }}
                          onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = ''; e.currentTarget.style.background = ''; }}
                          onClick={() => {
                            const activityId = activity.ID;
                            const count = activity.count || 0;

                            switch (activityId) {
                              case 1: // Profile
                                sessionStorage.setItem("summaryPage", "VendorRegistrationAU");
                                sessionStorage.setItem("focusSection", "companyProfile");
                                if (this.props.onNavigateToProfile) {
                                  this.props.onNavigateToProfile();
                                }
                                break;
                              case 2: // Work Order
                                sessionStorage.setItem("summaryPage", count === 1 ? "VendorWorkOrderAU" : "VendorWorkOrderList");
                                if (count === 1) {
                                  if (this.props.onNavigateToWorkOrder) {
                                    this.props.onNavigateToWorkOrder();
                                  }
                                } else {
                                  if (this.props.onNavigateToScopeOfWork) {
                                    this.props.onNavigateToScopeOfWork();
                                  }
                                }
                                break;
                              case 3: // Plan
                                sessionStorage.setItem("summaryPage", count === 1 ? "VendorPlanRecord" : "VendorPlan");
                                if (count === 1) {
                                  if (this.props.onNavigateToRecord) {
                                    this.props.onNavigateToRecord();
                                  }
                                } else {
                                  if (this.props.onNavigateToPlan) {
                                    this.props.onNavigateToPlan();
                                  }
                                }
                                break;
                              case 4: // Entry Pass
                                sessionStorage.setItem("summaryPage", "EntryPass");
                                if (this.props.onNavigateToEntryPass) {
                                  this.props.onNavigateToEntryPass();
                                }
                                break;
                              case 5: // Exit Pass
                                sessionStorage.setItem("summaryPage", "ExitPass");
                                if (this.props.onNavigateToExitPass) {
                                  this.props.onNavigateToExitPass();
                                }
                                break;
                            }
                          }}
                        >
                          <div className="card-body p-1" style={{ minHeight: '110px' }}>
                            <div className="d-flex justify-content-between align-items-center">
                              <h6 className="text-dark ">
                                {activity.Cardname || 'Activity Title'}
                              </h6>
                            </div>
                            <p className="mb-1 text-muted">
                              {activity.Details || 'Activity description'}
                            </p>

                            <div className="d-flex justify-content-between mb-0" style={{ visibility: activity.Duedate && activity.Duedate.trim() !== '' ? 'visible' : 'hidden' }}>
                              <span className="">Due Date: {(() => {
                                const dateStr = activity.Duedate;
                                if (!dateStr) return '';
                                const match = dateStr.match(/(\w+)\s+(\d+)\s+(\d{4})\s+(\d+:\d+[AP]M)/);
                                if (match) {
                                  const [, monthName, day, year, time] = match;
                                  const months = { Jan: 1, Feb: 2, Mar: 3, Apr: 4, May: 5, Jun: 6, Jul: 7, Aug: 8, Sep: 9, Oct: 10, Nov: 11, Dec: 12 };
                                  const month = String(months[monthName]).padStart(2, '0');
                                  return `${day.padStart(2, '0')}/${month}/${year}, ${time}`;
                                }
                                return dateStr;
                              })()}</span>
                              <span className="text-danger">
                                {activity.Daysleft || ''}
                              </span>
                            </div>

                            {/* <div className="d-flex justify-content-between align-items-center">
                                  <span className="">Days Left:</span>
                                  <span
                                    className="badge text-dark"
                                    style={{ background: "#ddd" }}
                                  >
                                    {activity.Daysleft || '0'} Days
                                  </span>
                                </div> */}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  {/* row end */}
                </div>
              </div>
            </div>
          </div>
          {!hasOnlyService32 && (
            <div className="row mb-2">
              <div className="col-12">
                <div className="card border shadow-none p-0 mb-1">
                  <div className="card-header d-flex flex-wrap justify-content-between align-items-center gap-2 py-1 bg-light">

                    {/* Left Side Title */}
                    <h6 className="card-title mb-0 py-1">
                      Application Summary
                    </h6>

                    {/* Right Side Status */}
                    <div className="d-flex align-items-center gap-1">

                      <span
                        className="status-pill d-flex align-items-center pt-0"
                        style={{
                          borderRight: "1px solid #ddd",
                          paddingRight: "10px", height: '15px'
                        }}
                      >
                        Confirmed:
                        <strong className="ms-1">
                          {dashboardData?.applicationSummaryGrid?.reduce(
                            (sum, row) => sum + (row.confirmed || row.Confirmed || 0),
                            0
                          ) || 0}
                        </strong>
                      </span>

                      <span
                        className="status-pill d-flex align-items-center pt-0"
                      >
                        Pending:
                        <strong className="ms-1">
                          {dashboardData?.applicationSummaryGrid?.reduce(
                            (sum, row) => sum + (row.pending || row.Pending || 0),
                            0
                          ) || 0}
                        </strong>
                      </span>

                    </div>

                  </div>
                  <div className="card-body pt-2 px-2">
                    {/* Status Row */}


                    {/* Table */}
                    <div className="table-responsive">
                      <table className="table table-dark-custom table-hover table-bordered mb-0">
                        <thead>
                          <tr>
                            <th>
                              Service
                            </th>
                            <th
                              className="text-center"
                            >
                              Confirmed
                            </th>
                            <th
                              className="text-center"
                            >
                              Pending
                            </th>
                            {/* <th
                                style={{ backgroundColor: "#f1f1f1" }}
                                className="text-center"
                              >
                                Approved
                              </th>
                              <th
                                style={{ backgroundColor: "#f1f1f1" }}
                                className="text-center"
                              >
                                Refused
                              </th> */}
                          </tr>
                        </thead>

                        <tbody>
                          {dashboardData?.applicationSummaryGrid?.map((row, index) => (
                            <tr key={index}>
                              <td>{row.service || row.Service || 'Service'}</td>
                              <td
                                className="text-center"
                                style={{ cursor: 'pointer', color: '#4daf9f' }}
                                onClick={() => {
                                  sessionStorage.setItem("summaryPage", "vendorExhibitionList");
                                  sessionStorage.setItem("filterStatusID", "2");
                                  sessionStorage.setItem("filterServiceName", row.service || row.Service || '');
                                  if (this.props.onNavigateToOrder) {
                                    this.props.onNavigateToOrder();
                                  }
                                }}
                              >{row.confirmed || row.Confirmed || 0}</td>
                              <td
                                className="text-center"
                                style={{ cursor: 'pointer', color: '#4daf9f' }}
                                onClick={() => {
                                  sessionStorage.setItem("summaryPage", "vendorExhibitionList");
                                  sessionStorage.setItem("filterStatusID", "1");
                                  sessionStorage.setItem("filterServiceName", row.service || row.Service || '');
                                  if (this.props.onNavigateToOrder) {
                                    this.props.onNavigateToOrder();
                                  }
                                }}
                              >{row.pending || row.Pending || 0}</td>
                              {/* <td className="text-center">{row.approved || row.Approved || 0}</td> */}
                              {/* <td className="text-center">{row.refused || row.Refused || 0}</td> */}
                            </tr>
                          )) || (
                              // Fallback static data
                              <>
                                <tr>
                                  <td>Power</td>
                                  <td className="text-center">0</td>
                                  <td className="text-center">0</td>
                                  {/* <td className="text-center">0</td>
                                  <td className="text-center">0</td> */}
                                </tr>
                                <tr>
                                  <td>Water</td>
                                  <td className="text-center">0</td>
                                  <td className="text-center">0</td>
                                  {/* <td className="text-center">0</td>
                                  <td className="text-center">0</td> */}
                                </tr>
                              </>
                            )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </main>
      </>
    );
  }
}

export default withRouter(connect(null, {
  getVendorDashboardData_action
})(VendorDashboard));